'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './density_compliance.routes';

export class DensityComplianceComponent {
  /*@ngInject*/
  constructor() {
    this.message = 'Hello';
  }
}

export default angular.module('appApp.density_compliance', [uiRouter])
  .config(routes)
  .component('densityCompliance', {
    template: require('./density_compliance.html'),
    controller: DensityComplianceComponent,
    controllerAs: 'densityComplianceCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/density/density_compliance/density_compliance.component.js